<app-breadcrumbs [data]="breadcrumbs"></app-breadcrumbs>
<app-progress></app-progress>
<div class="p-8 table-list mat-typography">
  <mat-card>
    <mat-card-header>
        <mat-card-title>
            <div class="flex items-center justify-between w-full">
            <span>
              {{dataSource && dataSource.data ? (dataSource.data.length | i18nPlural: accountPluralMapping) : '0 Accounts'}}
            </span>
                @if (admin) {
                    <a
                        [routerLink]="['/accounts/add']"
                        aria-label="Add Account"
                        color="primary"
                        mat-raised-button
                    >
                        Create New Account
                    </a>
                }
            </div>
        </mat-card-title>
        <mat-card-subtitle>
        <mat-form-field>
          <input (keyup)="search($event)" matInput placeholder="Search">
        </mat-form-field>
      </mat-card-subtitle>
    </mat-card-header>
    <mat-card-content class="mat-elevation-z8">
      <table [dataSource]="dataSource" mat-table matSort [matSortDisableClear]="true">
        <!-- Name Column -->
        <ng-container matColumnDef="name">
          <th *matHeaderCellDef mat-header-cell mat-sort-header>Name</th>
          <td *matCellDef="let row" mat-cell><a [routerLink]="['/facilities/', row.id]">{{row.name}}</a></td>
        </ng-container>

        <!-- Actions Column -->
        <ng-container matColumnDef="actions">
          <th *matHeaderCellDef class="column-less" mat-header-cell>Actions</th>
          <td *matCellDef="let row" mat-cell>
              <div class="flex items-center gap-2">
            @if (admin) {
              <button [routerLink]="['/accounts/edit/', row.id]" class="mat-elevation-z0" color="primary"
                matTooltip="Edit"
                matTooltipPosition="before"
                mat-mini-fab><i class="material-icons">edit</i></button>
              }
              <button [routerLink]="['/account-users/', row.id]" class="mat-elevation-z0" color="primary"
                matTooltip="Users"
                matTooltipPosition="after"
                mat-mini-fab><i
              class="material-icons">supervisor_account</i></button>
              </div>
            </td>
          </ng-container>

          <tr *matHeaderRowDef="displayedColumns" mat-header-row></tr>
          <tr *matRowDef="let row; columns: displayedColumns;" mat-row></tr>
        </table>
        <mat-paginator [pageSizeOptions]="[15, 50, 100]" [showFirstLastButtons]="true"></mat-paginator>
      </mat-card-content>
    </mat-card>
  </div>
